import { css } from "styled-system/css";

export const cardContainerStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.125rem",
  cursor: "pointer",
  borderRadius: 0,
});

export const imageWrapperStyles = css({
  position: "relative",
  width: "100%",
  aspectRatio: "2/3",
  transitionProperty: "transform",
  transitionDuration: "300ms",
});

export const imageContainerStyles = css({
  borderRadius: "0.375rem",
  borderWidth: "1px",
  borderStyle: "solid",
  boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  backgroundColor: "bgBase300",
  borderColor: "bgBase300",
});

export const imageStyles = css({
  width: "100%",
  height: "100%",
  objectFit: "cover",
});

export const progressOverlayStyles = css({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  backdropFilter: "blur(2px)",
});

export const progressBadgeStyles = css({
  display: "flex",
  alignItems: "center",
  gap: "sm",
  paddingInline: "md",
  paddingY: "0.375rem",
  backgroundColor: "bgBase100",
  borderRadius: "full",
  boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
});

export const progressDotStyles = css({
  width: "0.5rem",
  height: "0.5rem",
  backgroundColor: "primary",
  borderRadius: "full",
});

export const progressTextStyles = css({
  fontSize: "11px",
  fontWeight: "900",
  color: "primary",
});

export const infoContainerStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.125rem",
  paddingInline: "0.25rem",
  marginTop: "xs",
});

export const titleStyles = css({
  fontSize: "11px",
  fontWeight: "700",
  color: "textBase",
  lineHeight: 1.25,
  marginBottom: "sm",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  // @ts-expect-error WebkitBoxOrient for line-clamp
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  transitionProperty: "color",
  transitionDuration: "200ms",
});

export const titleHoverStyles = css({
  color: "primary",
});

export const statsStyles = css({
  fontSize: "11px",
  fontWeight: "500",
  color: "color-mix(in srgb, {colors.textBase}, transparent 50%)",
});

export const statusRowStyles = css({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "sm",
  marginBottom: "0.25rem",
});

export const badgeBaseStyles = css({
  paddingInline: "0.375rem",
  paddingY: "0.125rem",
  fontSize: "9px",
  fontWeight: "900",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  borderRadius: "0.375rem",
  borderWidth: "1px",
  borderStyle: "solid",
});

export const badgeStatusCompletedStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.success}, transparent 90%)",
  color: "success",
  borderColor: "color-mix(in srgb, {colors.success}, transparent 80%)",
});

export const badgeStatusOngoingStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.info}, transparent 90%)",
  color: "info",
  borderColor: "color-mix(in srgb, {colors.info}, transparent 80%)",
});

export const badgeStatusHiatusStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.warning}, transparent 90%)",
  color: "warning",
  borderColor: "color-mix(in srgb, {colors.warning}, transparent 80%)",
});

export const badgeStatusDroppedStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.error}, transparent 90%)",
  color: "error",
  borderColor: "color-mix(in srgb, {colors.error}, transparent 80%)",
});

export const badgeStatusUnknownStyles = css({
  backgroundColor: "bgBase300",
  color: "color-mix(in srgb, {colors.textBase}, transparent 40%)",
  borderColor: "color-mix(in srgb, {colors.textBase}, transparent 80%)",
});

export const badgeDownloadFullStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.primary}, transparent 90%)",
  color: "primary",
  borderColor: "color-mix(in srgb, {colors.primary}, transparent 80%)",
});

export const badgeDownloadPartialStyles = css({
  backgroundColor: "bgBase300",
  color: "color-mix(in srgb, {colors.textBase}, transparent 40%)",
  borderColor: "color-mix(in srgb, {colors.textBase}, transparent 80%)",
});

export const badgeDownloadUnknownStyles = css({
  backgroundColor: "bgBase100",
  color: "color-mix(in srgb, {colors.textBase}, transparent 70%)",
  borderColor: "color-mix(in srgb, {colors.textBase}, transparent 90%)",
});

export const sourceBadgeStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.primary}, transparent 90%)",
  color: "primary",
  borderColor: "color-mix(in srgb, {colors.primary}, transparent 80%)",
});
